import { Component } from '@angular/core';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { InvoiceBalanceSummarySplineAreaChart } from 'src/app/core/models/reporting/invoice-balance-summary-spline-area-chart';
import * as lodash from 'lodash';
import { ProgressChartDataModel, RequisitionStatusSummaryListState } from '../dashboard/dashboard.component';
import { RequisitionStatusSummaryModel } from 'src/app/core/models/requisition/requisition-status-summary-model.model';
import { ChartType } from '../dashboard/dashboard.model';
import { GlobalComponent } from 'src/app/global-component';
import { AuthMyfileService, UserContextType } from 'src/app/core/services/auth.myfile.service';
import { SecurityOperations } from 'src/app/core/security/security-operations';


@Component({
  selector: 'app-ecommerce',
  templateUrl: './ecommerce.component.html',
  styleUrls: ['./ecommerce.component.scss']
})
export class EcommerceComponent {

  breadCrumbItems!: Array<{}>;
  statData!: any;
  salesForecastChart: any;
  DealTypeChart: any;
  splineAreaChart: any;
  DealsStatus: any;
  UpcomingActivities: any;
  ClosingDeals: any;
  value: number = 0;
  witnessChart!: ChartType;
  myfileChart!: ChartType;

  userContext: UserContextType = this.authService.currentUserContextValue; 
  canViewAllInvoicesButton: boolean = false;
  dashboardDataModel: RequisitionStatusSummaryModel = new RequisitionStatusSummaryModel;
  progressChartsModel: ProgressChartDataModel = new ProgressChartDataModel();

  searchModel: RequisitionStatusSummaryListState = {
    sortColumnDirective: 'modifiedDate',
    sortDirectionDirective: 'desc',
    pageSize: GlobalComponent.defaultPagingInfo.pageSize,
    pageIndex: 0,
    startIndex: 1,
    sortColumn: '',
    sortDirection: 'desc',
    searchTerm: '',
    from: '2023-01-01T00:00:00',
    to: '2023-12-31T00:00:00'
  };

  witnessChartValues = {
    series: [{
      name: 'Draft',
      type: 'line',
      data: this.progressChartsModel.draftsData
    }, {
      name: 'Submitted',
      type: 'line',
      data: this.progressChartsModel.submittedData
    },
    {
      name: 'Processing',
      type: 'line',
      data: this.progressChartsModel.processingData
    }, {
      name: 'Completed',
      type: 'line',
      data: this.progressChartsModel.completedData
    },{
      name: 'Incomplete',
      type: 'line',
      data: this.progressChartsModel.incompleteData
    }],
    color: '["--vz-secondary", "--vz-primary","--vz-warning", "--vz-success", "--vz-danger"]',
  }
  
  constructor(
    public myFileApiService: MyfileApiService,
    public authService: AuthMyfileService
    ) { }

  ngOnInit(): void {
    //breadcrum
    this.breadCrumbItems = [
      { label: 'Dashboards' },
      { label: 'Ecommerce', active: true }
    ];
    this.fetchData();
    this._splineAreaChart('["--vz-primary", "--vz-success", "--vz-danger"]');

    this.witnessChart = this._progressChart(this.witnessChartValues, 5);
    this.canViewAllInvoicesButton = this.authService.canAccessOperation(SecurityOperations.invoice.invoiceManagement);
  }

  getInvoiceBalanceSummary(value: any) {
    var fromDate = new Date();
    var toDate = new Date();

    if (value == 'last_year') {
      fromDate = new Date(fromDate.getFullYear() - 1, 0, 1);
      toDate = new Date(toDate.getFullYear() - 1, 11, 31);
      this.splineAreaChart.currentSortBy = this.splineAreaChart.sortOptions[1];
    }
    else if (value == 'all') {
      fromDate = new Date(2022, 0, 1); //from genesis
      toDate = new Date(new Date().getFullYear(), 11, 31);
      this.splineAreaChart.currentSortBy = this.splineAreaChart.sortOptions[2];
    }
    else {
      fromDate = new Date(fromDate.getFullYear(), 0, 1);
      toDate = new Date(toDate.getFullYear(), 11, 31);
      this.splineAreaChart.currentSortBy = this.splineAreaChart.sortOptions[0];
    }

    this.myFileApiService.getInvoiceBalanceSummaryReport(fromDate, toDate)
      .subscribe(res => {
        if (res) {
          this.loadInvoiceBalanceSummaryChart(res);
        }
      });
  }

  private getChartColorsArray(colors: any) {
    colors = JSON.parse(colors);
    return colors.map(function (value: any) {
      var newValue = value.replace(" ", "");
      if (newValue.indexOf(",") === -1) {
        var color = getComputedStyle(document.documentElement).getPropertyValue(newValue);
        if (color) {
          color = color.replace(" ", "");
          return color;
        }
        else return newValue;;
      } else {
        var val = value.split(',');
        if (val.length == 2) {
          var rgbaColor = getComputedStyle(document.documentElement).getPropertyValue(val[0]);
          rgbaColor = "rgba(" + rgbaColor + "," + val[1] + ")";
          return rgbaColor;
        } else {
          return newValue;
        }
      }
    });
  }

  private _splineAreaChart(colors: any) {
    colors = this.getChartColorsArray(colors);

    var fromDate = new Date(2022, 0, 1); //from genesis
    var toDate = new Date(new Date().getFullYear(), 11, 31);

    this.splineAreaChart = {

      sortOptions: [
        `Current Year`,
        `Last Year`,
        `All ${fromDate.getFullYear()} - ${toDate.getFullYear()}`
      ],
      series: [],
      chart: {
        height: 290,
        type: 'area',
        toolbar: 'false',
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: 'smooth',
        width: 2,
      },
      xaxis: {
        categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      },
      yaxis: {
        tickAmount: 5,
        min: 0,
        //max: 500
      },
      colors: colors,
      fill: {
        opacity: 0.06,
        type: 'solid'
      },
      totalInvoiced: 0,
      totalPayments: 0,
      totalUnpaid: 0,
      totalRefunded: 0,
      totalFees: 0,
    };

    this.splineAreaChart.currentSortBy = this.splineAreaChart.sortOptions[0];
  }

  clearCharts() {
    this.progressChartsModel.categories = [];
    this.progressChartsModel.draftsData = [];
    this.progressChartsModel.submittedData = [];
    this.progressChartsModel.processingData = [];
    this.progressChartsModel.completedData = [];
    this.progressChartsModel.incompleteData = [];
  }

  setLines(numLines: number, numValue:number): number[]{
    var array = []
    for (let index = 0; index < numLines; index++) {
      array.push(numValue)
    }
    return array; 
  }

  private _progressChart(chartValues: any, lines: number) {

    return {
      chart: {
        height: 370,
        type: "line",

        toolbar: {
          show: false,
        },
      },
      stroke: {
        curve: "straight",
        dashArray: this.setLines(lines, 0),
        width: this.setLines(lines, 2),
      },
      colors: this.getChartColorsArray(chartValues.color),
      series: chartValues.series,
      fill: {
        opacity: this.setLines(lines, 1),
      },
      markers: {
        size: this.setLines(lines, 0),
        strokeWidth: 2,
        hover: {
          size: 4,
        },
      },
      xaxis: {
        categories: this.progressChartsModel.categories,
        axisTicks: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
      },
      grid: {
        show: false,
      },
    };
  }
  private fetchData() {
    var fromDate = new Date(new Date().getFullYear(), 0, 1);
    var toDate = new Date(new Date().getFullYear(), 11, 31);

    this.myFileApiService.getInvoiceBalanceSummaryReport(fromDate, toDate)
      .subscribe(res => {
        if (res) {
          this.loadInvoiceBalanceSummaryChart(res);
        }
      });

    this.myFileApiService.getRequisitionStatusSummary(this.searchModel)
      .subscribe((result?: RequisitionStatusSummaryModel) => {
        if (result) {
          this.dashboardDataModel = result;
          this.clearCharts();
          if (result.data) {
            result.data.forEach(data => {
              this.progressChartsModel.categories.push(this.convertDateToTitle(data.date!));
              this.progressChartsModel.draftsData.push(data.draft!);
              this.progressChartsModel.submittedData.push(data.submitted!);
              this.progressChartsModel.processingData.push(data.processing!);
              this.progressChartsModel.completedData.push(data.completed!);
              this.progressChartsModel.incompleteData.push(data.incompleted!);
            });
          }
          this.witnessChart.series[0].data = this.progressChartsModel.draftsData;
          this.witnessChart.series[1].data = this.progressChartsModel.submittedData;
          this.witnessChart.series[2].data = this.progressChartsModel.processingData;
          this.witnessChart.series[3].data = this.progressChartsModel.completedData;
          this.witnessChart.series[4].data = this.progressChartsModel.incompleteData;

          this.witnessChart = this._progressChart(this.witnessChartValues, 5);
        }
      });
  }

  convertDateToTitle(date: Date): string {
    var string = date.toString().split('T')[0];
    string = `${string.split('-')[1]}-${string.split('-')[0]}`;
    return string;
  }


  private loadInvoiceBalanceSummaryChart(invoiceChart: InvoiceBalanceSummarySplineAreaChart) {
    if (invoiceChart) {
      this.splineAreaChart.totalInvoiced = invoiceChart.totalInvoiced;
      this.splineAreaChart.totalPayments = invoiceChart.totalPayments;
      this.splineAreaChart.totalRefunded = invoiceChart.totalRefunded;
      this.splineAreaChart.totalUnpaid = invoiceChart.totalUnpaid;
      this.splineAreaChart.totalFees = invoiceChart.totalFees;
      this.splineAreaChart.yaxis.max = invoiceChart.yAxisMaxTotal;

      var data = Array<any>();

      var invoiced = {
        name: "Invoiced",
        data: Array<number | undefined>()
      };

      data.push(invoiced);

      var payments = {
        name: "Payments",
        data: Array<number | undefined>()
      };

      data.push(payments);

      var unpaid = {
        name: "Unpaid",
        data: Array<number | undefined>()
      };

      data.push(unpaid);

      if (invoiceChart.totalMonths != undefined && invoiceChart.totalMonths <= 12) {
        invoiceChart.data.forEach(x => {
          invoiced.data.push(x.invoiced);
        });

        invoiceChart.data.forEach(x => {
          payments.data.push(x.payments);
        });

        invoiceChart.data.forEach(x => {
          unpaid.data.push(x.unpaid);
        });
      }
      else {
        var result = lodash.groupBy(invoiceChart.data, "month");

        for (var i = 1; result[i]; i++) {
          var grouped = result[i];

          invoiced.data.push(lodash.sumBy(grouped, 'invoiced'));
          unpaid.data.push(lodash.sumBy(grouped, 'unpaid'));
          payments.data.push(lodash.sumBy(grouped, 'payments'));
        }
      }

      this.splineAreaChart.series = data;
    }
  }

}
